import React from "react";
import { UMSSBlue, UMSSBlueLight, UMSSGold, UMSSGoldLight } from "../utils/colors";

function LocationMap({ location, onClose }) {
  if (!location) return null;
  
  const address = encodeURIComponent(location.address || "");
  const embedUrl = `https://www.google.com/maps?q=${address}&output=embed`;
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${address}`;
  const openUrl = `https://www.google.com/maps/search/?api=1&query=${address}`;

return (
    <div style={{ 
        animation: "fadeIn 1s ease-in-out", // Increased duration to 1s
        border: "1px solid #ccc", 
        borderRadius: "15px", 
        padding: "1rem", 
        paddingBottom: "1rem", // Added bottom padding
        marginTop: "1rem", 
        position: "relative" 
    }}>
        {/* FadeIn keyframes */}
        <style>{`
            @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
            }
        `}</style>
        <div style={{ position: "absolute", top: "0.5rem", right: "0.5rem" }}>
            <button onClick={onClose} style={{ background: "transparent", border: "none", fontSize: "1rem", cursor: "pointer" }}>×</button>
        </div>
        <h3>{location.name || location.id}</h3>
        {location.address && <p>{location.address}</p>}
        <div style={{ width: "100%", height: "300px", marginBottom: "1rem" }}>
            <iframe 
                title="Location Map"
                width="100%"
                height="100%"
                frameBorder="0"
                style={{ border: 0 }}
                src={embedUrl}
                allowFullScreen
            ></iframe>
        </div>
        <div style={{ 
            display: "flex", 
            justifyContent: "space-between", 
            gap: "1rem" // added gap between buttons
        }}>
            <a 
                href={directionsUrl} 
                target="_blank" 
                rel="noreferrer"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.75rem",
                    padding: "0.75rem 1.5rem",
                    backgroundColor: UMSSGold,
                    color: "#fff",
                    textDecoration: "none",
                    borderRadius: "8px",
                    fontWeight: "600",
                    fontSize: "1rem",
                    transition: "background-color 0.2s ease-in-out, transform 0.1s ease-in-out",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    cursor: "pointer"
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = UMSSGoldLight} // Darken on hover
                onMouseLeave={(e) => e.target.style.backgroundColor = UMSSGold}
                onMouseDown={(e) => e.target.style.transform = "scale(0.97)"} // Click effect
                onMouseUp={(e) => e.target.style.transform = "scale(1)"}
            >
                🚗 Get Directions
            </a>

            <a 
                href={openUrl} 
                target="_blank" 
                rel="noreferrer"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.75rem",
                    padding: "0.75rem 1.5rem",
                    backgroundColor: UMSSBlue,
                    color: "#fff",
                    textDecoration: "none",
                    borderRadius: "8px",
                    fontWeight: "600",
                    fontSize: "1rem",
                    transition: "background-color 0.2s ease-in-out, transform 0.1s ease-in-out",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    cursor: "pointer"
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = UMSSBlueLight} // Darken on hover
                onMouseLeave={(e) => e.target.style.backgroundColor = UMSSBlue}
                onMouseDown={(e) => e.target.style.transform = "scale(0.97)"} // Click effect
                onMouseUp={(e) => e.target.style.transform = "scale(1)"}
            >
                🗺 Open in Google Maps
            </a>
        </div>
    </div>
);
}

export default LocationMap;
